export default "__VITE_ASSET__DX6YC$tf__"